const assignment = {

  assignedCasesWithAppts() {
    return `/assignment/insurance/case/all-assigned`;
  },
  config(mode) {
    return `/assignment/${mode}/config`;
  },
  caseLocations(mode) {
    return `/assignment/${mode}/case/location`;
  },
  inspectorLocations(mode) {
    return `/assignment/${mode}/inspector/location`;
  },
  zipCodes() {
    return `/regions/zip-codes`;
  },
  caseDetails(mode) {
    return `/assignment/${mode}/case`;
  },
  assignedCases(mode, inspectorNumber) {
    return `/assignment/${mode}/inspector/${inspectorNumber}/cases`;
  },
  inspectorDetails(mode, inspectorNumber) {
    return `/assignment/${mode}/inspector/${inspectorNumber}`;
  },
  assign(mode) {
    return `/assignment/${mode}/case/assign`;
  },
  unassign(mode) {
    return `/assignment/${mode}/case/unassign`;
  },
  caseCount(mode) {
    return `/assignment/${mode}/case/count`;
  },
};

export default assignment;